const RosterHeader = ({ month, year, setMonth, setYear }) => (
  <div className="flex flex-wrap gap-4 mb-0 items-center text-xs text-textGray">
    <select
      value={month}
      onChange={(e) => setMonth(+e.target.value)}
      className="bg-dry border border-border px-3 py-2 rounded"
    >
      {Array.from({ length: 12 }).map((_, i) => (
        <option key={i} value={i}>
          {new Date(0, i).toLocaleString("en", { month: "long" })}
        </option>
      ))}
    </select>

    <select
      value={year}
      onChange={(e) => setYear(+e.target.value)}
      className="bg-dry border border-border px-3 py-2 rounded"
    >
      {[year - 1, year, year + 1].map((y) => (
        <option key={y}>{y}</option>
      ))}
    </select>
  </div>
);

export default RosterHeader;
